import RADEnvironmentProxy from '@/Communication/RADEnvironmentProxy';
import { IResultDTO } from "coreframetypings/dto";
import { Dictionary } from '#/DefaultViewExtensionInterfaces';
import ComponentManager from '@/Management/ComponentManager';
import NavigationService from '@/Management/NavigationService';
import RADApplication from '@/Management/RADApplication';
import * as DownloadHelper from '@/Utility/DownloadHelper';

export default class ExceptionInfoHelper {

    public static downloadExceptionInfo(errorInformation: Dictionary<string>): void {
        if (RADApplication.getInstance().configuration.guiErrorLevel != 'None') {
            errorInformation['Browser'] = window.navigator.userAgent;
            errorInformation['OS'] = window.navigator.platform;
            errorInformation['URL'] = NavigationService.getInstance().getStatefulAddress().toString();
        }
        const text = _.keys(errorInformation).map(x => `${x}: ${errorInformation[x]}`).join('\r\n');

        DownloadHelper.openDownloadDialogForInlineFile(text, 'ErrorLog.txt')

        if (RADApplication.getInstance().configuration.guiErrorLevel != 'High')
            return;

        RADEnvironmentProxy.getInstance().createLogZip({
            days: 1
        })
            .fail(() => {
                // do nothing
            })
            .then((resultDTO: IResultDTO) => {
                if (!String.isNullOrEmpty(resultDTO.returnValue)) 
                    DownloadHelper.openDownloadDialogFromApplicationAsync(resultDTO.returnValue);
            });
    }
}

ComponentManager.setUtility('ExceptionInfoHelper', ExceptionInfoHelper, 'RADPresentation.HTMLClient.DefaultViewExtensions');